import React, { useContext, useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styles/CreatePostForm.css";
import { toast } from "react-toastify";
import { TbCameraPlus } from "react-icons/tb";
import toastStyles from "../../styles/Toast.module.css";

function CreatePostForm() {
  const navigate = useNavigate();
  const { login, setLogin } = useContext(AuthContext);
  const [images, setImages] = useState(null);

  async function onCreatePostForm(e) {
    e.preventDefault();

    console.log("E", e.target[0].value, e.target[1].value, e.target[2].value);

    let response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "posts",

      {
        title: e.target[0].value,
        post: e.target[1].value,
        status: e.target[2].value,
      },

      {
        headers: {
          authToken: localStorage.getItem("AuthToken"),
        },
      }
    );

    console.log("risposta: ", response);

    if (response?.data?.id) {
      const data = new FormData();
      data.append("file", images);
      let imageResponse = await axios.post(
        process.env.REACT_APP_SERVER_URL +
          "images/upload/" +
          response?.data?.id,
        data,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            authToken: localStorage.getItem("AuthToken"),
          },
        }
      );
      console.log("Image upload response: ", imageResponse.data);
    }

    console.log(response.data);

    toast.success("Post creato!");
  }

  const onSetImage = (e) => {
    setImages(e.target.files[0]);
  };

  return (
    <form className="Entry" onSubmit={onCreatePostForm}>
      <h1>CREATE POST FORM</h1>
      <h2>{login?.username}</h2>
      <label htmlFor="title">Title</label>
      <input type="text" />
      <label htmlFor="textarea">Post Text</label>
      <textarea />
      <input
        type="file"
        accept="image/png, image/jpg"
        onChange={(e) => onSetImage(e)}
        // style={{ display: "none" }}
      />
      <label htmlFor="file-upload" className={toastStyles.menu}>
        <TbCameraPlus style={{ fontSize: "24px", cursor: "pointer" }} />
      </label>
      <button type="submit">Create</button>
      <div></div>
    </form>
  );
}

export default CreatePostForm;
